import React, { Component } from 'react';

import LocalDataManager from '../managers/LocalDataManager';

import GroupsService from '../services/GroupsService';

import GroupsTopBar from './Groups/GroupsTopBar';
import GroupsScannerOverlay from './Groups/GroupsScannerOverlay';
import GroupsViewCentral from './Groups/GroupsViewCentral';
import GroupsBottomBar from './Groups/GroupsBottomBar';


export default class GroupPage extends Component {
    constructor(props) {
        super(props);

        window.zzActiveObject = this;

        this.dbm = new LocalDataManager();

        this.groupsService = new GroupsService();

        this.defaultTopBarAction = this.defaultTopBarAction.bind(this);

        this.state = {
            groupModeIndex: 0,
            accountInfo: undefined,
            isScanMode: false,
            scannedQRText: "",
            topBarSettings: {
                icon: "refresh",
                actionFunction: () => { this.state.groupModeIndex === 0 ? this.getMyStackupGroups() : this.getMyMetricsGroups() },
                backFunction: null
            },
            myStackupGroups: [],
            yourStackupGroups: [],
            viewStackupGroups: [],
            myStackupActiveGroupId: null,
            myMetricsGroups: [],
            yourMetricsGroups: [],
            viewMetricsGroups: [],
            myMetricsActiveGroupId: null,
            deleteMemberId: null,
            myMetricsGroupsLocations: []
        }

        this.locationMap = {};
        this.groupLinks = [{
            label: 'Stack-Up',
            icon: 'person',
            index: 0
        }
            // {
            //     label: 'Metrics',
            //     icon: 'store_mall_directory',
            //     index: 1
            // }
        ];

        this.init = this.init.bind(this);

        this.handleNavChange = this.handleNavChange.bind(this);

        this.getMyStackupGroups = this.getMyStackupGroups.bind(this);
        this.getMyMetricsGroups = this.getMyMetricsGroups.bind(this);
        this.initialJoinGroup = this.initialJoinGroup.bind(this);
        this.locationJoinGroup = this.locationJoinGroup.bind(this);

        this.setTopBarSettings = this.setTopBarSettings.bind(this);
        this.setMyStackupActiveGroupId = this.setMyStackupActiveGroupId.bind(this);
        this.setMyMetricsActiveGroupId = this.setMyMetricsActiveGroupId.bind(this);
        this.setDeleteMemberId = this.setDeleteMemberId.bind(this);

        this.createNewStackupGroup = this.createNewStackupGroup.bind(this);
        this.createNewMetricsGroup = this.createNewMetricsGroup.bind(this);
        this.saveStackupGroup = this.saveStackupGroup.bind(this);
        this.saveMetricsGroup = this.saveMetricsGroup.bind(this);
        this.deleteGroup = this.deleteGroup.bind(this);
        this.deleteGroupMember = this.deleteGroupMember.bind(this);

        this.startScan = this.startScan.bind(this);
        this.stopScan = this.stopScan.bind(this);


        let self = this;
        self.props.superInit(self.init, undefined, undefined, undefined);
    }

    init() {
        let self = this;

        self.dbm.getAccountInfo().then((accountInfo) => {
            
            if(accountInfo.isDashboardOnly)
            {
                self.props.changePage('login', false);
                return;
            }
            self.locationMap = accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].locations.reduce((r, e) => {
                let key = e.locationID;
                if (!r[key]) {
                    r[key] = e.name;
                }

                return r;
            }, {});

            // if (accountInfo.userType === 0) {
            //     self.groupLinks.push({
            //         label: 'Metrics',
            //         icon: 'store_mall_directory',
            //         index: 1
            //     });
            // }

            self.getMyStackupGroups(accountInfo, (stackupGroups) => {
                self.getMyMetricsGroups(accountInfo, (metricsGroups) => {
                    if (metricsGroups.canViewMetricsGroups) {
                        self.groupLinks.push({
                            label: 'Metrics',
                            icon: 'store_mall_directory',
                            index: 1
                        });
                    }
                    self.setState({
                        accountInfo: accountInfo,
                        myStackupGroups: stackupGroups.myGroups,
                        yourStackupGroups: stackupGroups.joinGroups,
                        viewStackupGroups: stackupGroups.viewGroups,
                        myMetricsGroups: metricsGroups.myGroups,
                        yourMetricsGroups: metricsGroups.joinGroups,
                        viewMetricsGroups: metricsGroups.viewGroups,
                        myMetricsGroupsLocations: metricsGroups.myLocationList
                    }, () => {
                        self.props.loadingOff();
                    });
                });
            });
        });
    }

    handleNavChange(index) {
        if (this.state.groupModeIndex != index) {
            this.setState({
                groupModeIndex: index,
                isScanMode: false,
                scannedQRText: "",
                topBarSettings: {
                    icon: "refresh",
                    actionFunction: () => { this.state.groupModeIndex === 0 ? this.getMyStackupGroups() : this.getMyMetricsGroups() },
                    backFunction: null
                },
                myStackupActiveGroupId: null,
                myMetricsActiveGroupId: null,
                deleteMemberId: null
            });
        }
    }

    defaultTopBarAction() {
        this.state.groupModeIndex === 0 ? this.getMyStackupGroups() : this.getMyMetricsGroups()
    }

    getMyStackupGroups(accountInfo, successCallback) {
        let self = this;

        self.props.loadingOn();

        try {
            if (accountInfo === undefined) {
                accountInfo = self.state.accountInfo;
            }
            let payload = {
                clientAccountId: accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].clientAccountId,
                userId: accountInfo.userId
            }

            self.groupsService.getMyStackupGroups(payload, (successCallback != undefined ? successCallback : (groups) => {
                self.setState({ myStackupGroups: groups.myGroups, yourStackupGroups: groups.joinGroups, viewStackupGroups: groups.viewGroups, accountInfo: accountInfo }, () => {
                    self.props.loadingOff();
                });
            }), () => {
                self.setState({ accountInfo: accountInfo }, () => {
                    self.props.loadingOff();
                });
            });
        }
        catch (ex) {
            self.props.loadingOff();
        }
    }

    getMyMetricsGroups(accountInfo, successCallback) {
        let self = this;

        self.props.loadingOn();

        try {
            if (accountInfo === undefined) {
                accountInfo = self.state.accountInfo;
            }
            let payload = {
                clientAccountId: accountInfo.primaryClientAccount,
                userId: accountInfo.userId
            }

            self.groupsService.getMyMetricsGroups(payload, (groups) => {
                let organizedGroups = _.sortBy(Object.values(groups.myLocationList.reduce((r, e) => {
                    let key = e.clientAccountName + e.clientAccountId;
                    if (!r[key]) {
                        r[key] = {
                            id: e.clientAccountId,
                            name: e.clientAccountName,
                            locations: []
                        }
                    }

                    r[key].locations.push({
                        id: e.locationId,
                        name: e.locationName
                    })

                    return r;
                }, {})), x => x.name);
                organizedGroups.forEach(ca => {
                    ca.locations = _.sortBy(ca.locations, x => x.name);
                });

                groups.myLocationList = organizedGroups;

                if (successCallback != undefined) {
                    successCallback(groups);
                } else {
                    self.setState({
                        myMetricsGroups: groups.myGroups,
                        yourMetricsGroups: groups.joinGroups,
                        viewMetricsGroups: groups.viewGroups,
                        accountInfo: accountInfo,
                        myMetricsGroupsLocations: groups.myLocationList
                    }, () => {
                        self.props.loadingOff();
                    });
                }
            }, () => {
                self.setState({ accountInfo: accountInfo }, () => {
                    self.props.loadingOff();
                });
            });

            // self.groupsService.getMyMetricsGroups(payload, (successCallback != undefined ? successCallback : (groups) => {
            //     self.setState({
            //         myMetricsGroups: groups.myGroups,
            //         yourMetricsGroups: groups.joinGroups,
            //         viewMetricsGroups: groups.viewGroups,
            //         accountInfo: accountInfo,
            //         myMetricsGroupsLocations: metricsGroups.myLocationList
            //     }, () => {
            //         self.props.loadingOff();
            //     });
            // }), () => {
            //     self.setState({ accountInfo: accountInfo }, () => {
            //         self.props.loadingOff();
            //     });
            // });
        }
        catch (ex) {
            self.props.loadingOff();
        }
    }

    initialJoinGroup(code, cleanupCallback) {
        let payload = {
            clientAccountId: this.state.accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].clientAccountId,
            userId: this.state.accountInfo.userId,
            joinCode: code,
            groupId: -1,
            locationIds: []
        }

        let self = this;
        self.props.loadingOn();

        let joinFunc = self.state.groupModeIndex === 0 ? self.groupsService.joinStackupGroup : self.groupsService.joinMetricsGroup;

        joinFunc(payload, (rCode) => {
            if (this.state.groupModeIndex === 0) {
                self.getMyStackupGroups(undefined, (groups) => {
                    self.setState({ myStackupGroups: groups.myGroups, yourStackupGroups: groups.joinGroups, viewStackupGroups: groups.viewGroups }, () => {
                        self.props.loadingOff();
                        if (cleanupCallback) {
                            cleanupCallback(rCode);
                        }
                    });
                });
            } else {
                self.getMyMetricsGroups(undefined, (groups) => {
                    self.setState({ myMetricsGroups: groups.myGroups, yourMetricsGroups: groups.joinGroups, viewMetricsGroups: groups.viewGroups }, () => {
                        self.props.loadingOff();
                        if (cleanupCallback) {
                            cleanupCallback(rCode);
                        }
                    });
                });
            }
        }, (err) => {
            self.props.loadingOff();
            alert("An error occurred");
        });
    }

    locationJoinGroup(groupId, locationList, cleanupCallback) {
        let payload = {
            clientAccountId: this.state.accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].clientAccountId,
            userId: this.state.accountInfo.userId,
            joinCode: null,
            groupId: groupId,
            locationIds: locationList
        }

        let self = this;
        self.props.loadingOn();

        let joinFunc = self.state.groupModeIndex === 0 ? self.groupsService.joinStackupGroup : self.groupsService.joinMetricsGroup;

        joinFunc(payload, (rCode) => {
            if (this.state.groupModeIndex === 0) {
                self.getMyStackupGroups(undefined, (groups) => {
                    self.setState({ myStackupGroups: groups.myGroups, yourStackupGroups: groups.joinGroups, viewStackupGroups: groups.viewGroups }, () => {
                        self.props.loadingOff();
                        if (cleanupCallback) {
                            cleanupCallback(rCode);
                        }
                    });
                });
            } else {
                self.getMyMetricsGroups(undefined, (groups) => {
                    self.setState({ myMetricsGroups: groups.myGroups, yourMetricsGroups: groups.joinGroups, viewMetricsGroups: groups.viewGroups }, () => {
                        self.props.loadingOff();
                        if (cleanupCallback) {
                            cleanupCallback(rCode);
                        }
                    });
                });
            }
        }, (err) => {
            self.props.loadingOff();
            alert("An error occurred");
        });
    }

    setTopBarSettings(settings) {
        let topBarSettings = this.state.topBarSettings;

        Object.keys(settings).forEach(key => {
            topBarSettings[key] = settings[key];
        });

        this.setState({ topBarSettings: topBarSettings, deleteMemberId: (topBarSettings.backFunction === null ? null : this.state.deleteMemberId) });
    }

    setMyStackupActiveGroupId(id) {
        this.setState({ myStackupActiveGroupId: (id === this.state.myStackupActiveGroupId ? null : id) });
    }

    setMyMetricsActiveGroupId(id) {
        this.setState({ myMetricsActiveGroupId: (id === this.state.myMetricsActiveGroupId ? null : id) });
    }

    setDeleteMemberId(id) {
        this.setState({ deleteMemberId: (id === this.state.deleteMemberId ? null : id) });
    }

    createNewStackupGroup(groupForm, successCallback) {
        let self = this;

        self.props.loadingOn();
        try {
            this.groupsService.createStackupGroup(groupForm,
                () => {
                    if (successCallback) {
                        successCallback();
                    }

                    setTimeout(() => {
                        self.getMyStackupGroups();
                    }, 500);
                },
                () => {
                    self.props.loadingOff();
                    alert("An error occurred while creating group " + groupForm.name);
                }
            );
        } catch (ex) {
            self.props.loadingOff();
            alert("An error occurred while creating group " + groupForm.name);
        }
    }

    createNewMetricsGroup(groupForm, successCallback) {
        let self = this;

        self.props.loadingOn();
        try {
            this.groupsService.createMetricsGroup(groupForm,
                () => {
                    if (successCallback) {
                        successCallback();
                    }

                    setTimeout(() => {
                        self.getMyMetricsGroups();
                    }, 500);
                },
                () => {
                    self.props.loadingOff();
                    alert("An error occurred while creating group " + groupForm.name);
                }
            );
        } catch (ex) {
            self.props.loadingOff();
            alert("An error occurred while creating group " + groupForm.name);
        }
    }

    saveStackupGroup(groupForm, successCallback) {
        let self = this;

        self.props.loadingOn();
        try {
            self.groupsService.saveStackupGroup(groupForm,
                () => {

                    let payload = {
                        clientAccountId: self.state.accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].clientAccountId,
                        userId: self.state.accountInfo.userId
                    }

                    self.groupsService.getMyStackupGroups(payload, (groups) => {

                        let tmpTopBarSettings = self.state.topBarSettings;
                        tmpTopBarSettings.actionFunction = null;

                        self.setState({ myStackupGroups: groups.myGroups, yourStackupGroups: groups.joinGroups, viewStackupGroups: groups.viewGroups, topBarSettings: tmpTopBarSettings }, () => {
                            if (successCallback) {
                                successCallback();
                            }
                            self.props.loadingOff();
                        });
                    }, () => {
                        self.props.loadingOff();
                    });
                },
                () => {
                    self.props.loadingOff();
                    alert("An error occurred while saving group " + groupForm.name);
                }
            );
        } catch (ex) {
            self.props.loadingOff();
            alert("An error occurred while saving group " + groupForm.name);
        }
    }

    saveMetricsGroup(groupForm, successCallback) {
        let self = this;

        self.props.loadingOn();
        try {
            self.groupsService.saveMetricsGroup(groupForm,
                () => {

                    let payload = {
                        clientAccountId: self.state.accountInfo.primaryClientAccount,
                        userId: self.state.accountInfo.userId
                    }

                    self.groupsService.getMyMetricsGroups(payload, (groups) => {

                        let tmpTopBarSettings = self.state.topBarSettings;
                        tmpTopBarSettings.actionFunction = null;

                        self.setState({ myMetricsGroups: groups.myGroups, yourMetricsGroups: groups.joinGroups, viewMetricsGroups: groups.viewGroups, topBarSettings: tmpTopBarSettings }, () => {
                            if (successCallback) {
                                successCallback();
                            }
                            self.props.loadingOff();
                        });
                    }, () => {
                        self.props.loadingOff();
                    });
                },
                () => {
                    self.props.loadingOff();
                    alert("An error occurred while saving group " + groupForm.name);
                }
            );
        } catch (ex) {
            self.props.loadingOff();
            alert("An error occurred while saving group " + groupForm.name);
        }
    }

    deleteGroup(group) {
        zconfirm("Are you sure you want to delete " + group.name + "?", () => {
            let self = this;
            self.props.loadingOn();
            self.groupsService.deleteGroup({ groupId: group.groupId, groupMemberIdList: [] }, () => {
                if (this.state.groupModeIndex === 0) {
                    self.getMyStackupGroups();
                } else {
                    self.getMyMetricsGroups();
                }
            }, () => {
                alert("An error occurred while deleting group " + group.name);
                self.props.loadingOff();
            })
        });
    }

    deleteGroupMember(groupName, memberName, memberIdList, successCallback) {
        let self = this;
        zconfirm("Are you sure you want to delete " + memberName + " from " + groupName + "?", () => {
            self.props.loadingOn();
            self.groupsService.deleteGroupMember({ groupId: -1, groupMemberIdList: memberIdList }, () => {
                let payload = {
                    clientAccountId: self.state.accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].clientAccountId,
                    userId: self.state.accountInfo.userId
                }

                if (self.state.groupModeIndex === 1) {
                    payload.clientAccountId = self.state.accountInfo.primaryClientAccount;
                }

                self.groupsService.getMyStackupGroups(payload, (stackupGroups) => {
                    self.groupsService.getMyMetricsGroups(payload, (metricsGroups) => {
                        self.setState({
                            myStackupGroups: stackupGroups.myGroups,
                            yourStackupGroups: stackupGroups.joinGroups,
                            viewStackupGroups: stackupGroups.viewGroups,
                            myMetricsGroups: metricsGroups.myGroups,
                            yourMetricsGroups: metricsGroups.joinGroups,
                            viewMetricsGroups: metricsGroups.viewGroups
                        }, () => {
                            if (successCallback) {
                                successCallback();
                            }
                            self.props.loadingOff();
                        });
                    });
                }, () => {
                    self.props.loadingOff();
                });
            }, () => {
                alert("An error occurred while deleting group member " + memberName);
                self.props.loadingOff();
            });
        });
    }

    startScan(successCallback) {
        let self = this;
        if (window.QRScanner != undefined) {
            window.QRScanner.scan((error, text) => {
                if (error) {
                    self.stopScan();
                } else {

                    self.stopScan();
                    self.initialJoinGroup(text, successCallback)

                    // self.setState({ scannedQRText: text }, () => { 
                    //     self.stopScan(); 

                    // });
                }
            });
            self.setState({ isScanMode: true }, () => {
                window.QRScanner.show();
                document.getElementById("universal-background").style.opacity = "0";
            });
        } else {
            
        }
    }

    stopScan() {
        let self = this;

        self.setState({ isScanMode: false }, () => {
            document.getElementById("universal-background").style.opacity = "1";

            if (window.QRScanner != undefined) {
                setTimeout(() => {
                    window.QRScanner.destroy();
                }, 500);
            }
        });
    }

    render() {

        let createNewGroup = this.state.groupModeIndex === 0 ? this.createNewStackupGroup : this.createNewMetricsGroup;

        let myGroups = this.state.groupModeIndex === 0 ? this.state.myStackupGroups : this.state.myMetricsGroups;
        let yourGroups = this.state.groupModeIndex === 0 ? this.state.yourStackupGroups : this.state.yourMetricsGroups;
        let viewGroups = this.state.groupModeIndex === 0 ? this.state.viewStackupGroups : this.state.viewMetricsGroups;

        let activeGroupId = this.state.groupModeIndex === 0 ? this.state.myStackupActiveGroupId : this.state.myMetricsActiveGroupId;
        let setMyActiveGroupId = this.state.groupModeIndex === 0 ? this.setMyStackupActiveGroupId : this.setMyMetricsActiveGroupId;

        let saveGroup = this.state.groupModeIndex === 0 ? this.saveStackupGroup : this.saveMetricsGroup;

        return (
            <div>
                <GroupsScannerOverlay isScanMode={this.state.isScanMode} startScan={this.startScan} stopScan={this.stopScan} />
                <GroupsTopBar topBarSettings={this.state.topBarSettings} isScanMode={this.state.isScanMode} toggleNav={this.props.toggleNav} />
                <GroupsViewCentral
                    groupModeIndex={this.state.groupModeIndex}
                    topBarSettings={this.state.topBarSettings}
                    defaultTopBarAction={this.defaultTopBarAction}
                    createNewGroup={createNewGroup}
                    setTopBarSettings={this.setTopBarSettings}
                    locationMap={this.state.groupModeIndex === 0 ? this.locationMap : this.state.myMetricsGroupsLocations}
                    accountInfo={this.state.accountInfo}
                    isScanMode={this.state.isScanMode}
                    startScan={this.startScan}
                    stopScan={this.stopScan}
                    myGroups={myGroups}
                    yourGroups={yourGroups}
                    viewGroups={viewGroups}
                    activeGroupId={activeGroupId}
                    setMyActiveGroupId={setMyActiveGroupId}
                    setDeleteMemberId={this.setDeleteMemberId}
                    deleteMemberId={this.state.deleteMemberId}
                    saveGroup={saveGroup}
                    deleteGroup={this.deleteGroup}
                    deleteGroupMember={this.deleteGroupMember}
                    startScan={this.startScan}
                    initialJoinGroup={this.initialJoinGroup}
                    locationJoinGroup={this.locationJoinGroup}
                />
                <GroupsBottomBar
                    isScanMode={this.state.isScanMode}
                    groupModeIndex={this.state.groupModeIndex}
                    links={this.groupLinks}
                    handleNavChange={this.handleNavChange}
                />
            </div>
        )
    }
}